import { CoreActivityItemModel } from '../../api/models';
import { VisibilityFunctions } from '../types';
import { find } from 'lodash';

const ArrayHasEntry = (value: any | undefined | null) => value !== undefined && value.length > 0;

export const applicationInclusion234 = (values: Partial<CoreActivityItemModel>) => {
    // these options are from Application Inclusion page: LevyPaidRSP / RSP/ CRC
    return ArrayHasEntry(values.levyCollectingRspItems) || ArrayHasEntry(values.rspNonLevyItems) || ArrayHasEntry(values.crcItems);
};

export const activitiesPerformedBy234 = (values: Partial<CoreActivityItemModel>) => {
    return ['RnDCompanyAndOthers', 'EitherASubsidiary', 'OnlyOthers'].includes(values.activitiesPerformedBy!);
};

export const activitiesPerformedBy123 = (values: Partial<CoreActivityItemModel>) => {
    return ['OnlyTheRnDCompany', 'RnDCompanyAndOthers', 'EitherASubsidiary'].includes(values.activitiesPerformedBy!);
};

export const otherOrganisationOptions134 = (values: Partial<CoreActivityItemModel>) => {
    return !applicationInclusion234(values) || values.otherOrganisation == null || ['YesRSP', 'YesCRC', 'No'].includes(values.otherOrganisation);
};

export const otherOrganisationOptions123 = (values: Partial<CoreActivityItemModel>) => {
    return ['YesRSP', 'YesRSPLevy', 'YesCRC'].includes(values.otherOrganisation!);
};

export const outcomeOptions1234 = (values: Partial<CoreActivityItemModel>) =>
(values.outcome !== undefined
    && (
        values.outcome.includes('NoInformation')
        || values.outcome.includes('NoSolution')
        || values.outcome.includes('CannotAdapt')
        || values.outcome.includes('Other')
    )
);

export const showEvidenceAvailableOther = (values: Partial<CoreActivityItemModel>) => {
    const optionOther = find(values.evidenceAvailable, r => r === 'Other') ? true : false;
    return optionOther;
};

export const isHeadMecGroup = (values: CoreActivityItemModel | Partial<CoreActivityItemModel>) => {
    return values.organisationMecType !== undefined && values.organisationMecType === 'HeadMecGroup';
};

const coreActivities: VisibilityFunctions<CoreActivityItemModel> = {
    /* Q.67   */ companyName: activitiesPerformedBy234,
    /* Q.68   */ isEntityConductingActivityConnectedOrAffiliated: activitiesPerformedBy234,
    /* Q.69   */ isActivityRnDEntityLocatedOutsideAustralia: activitiesPerformedBy234,
    /* Q.70   */ activityConductedBy: values => isHeadMecGroup(values) && activitiesPerformedBy123(values),
    // tslint:disable-next-line:max-line-length
    /* Q.71   */ subsidiaryConductAbn: values => isHeadMecGroup(values) && activitiesPerformedBy123(values) && values.activityConductedBy === 'Subsidiary',
    /* Q.72   */ companyCountryOfResidence: activitiesPerformedBy234,
    // tslint:disable-next-line:max-line-length
    /* Q.75   */ otherOrganisation: applicationInclusion234,
    /* Q.76   */ isActivityCoveredByIRDD: otherOrganisationOptions134,
    /* Q.77   */ determinationRelyingOn: values => otherOrganisationOptions134(values) && values.isActivityCoveredByIRDD === 'Yes',
    /* Q.78   */ outcome: otherOrganisationOptions134,
    /* Q.79   */ sourcesInvestigated: values => outcomeOptions1234(values) && otherOrganisationOptions134(values) && values.futureCoreActivity === 'No',
    /* Q.80   */ competentProfesionalReason: values => outcomeOptions1234(values) && otherOrganisationOptions134(values) && values.futureCoreActivity === 'No',
    // tslint:disable-next-line:max-line-length
    /* Q.81   */ whyNoInvestigation: values => otherOrganisationOptions134(values) && values.futureCoreActivity === 'No' && values.outcome !== undefined && values.outcome.includes('None'),
    /* Q.82   */ hypothesis: values => otherOrganisationOptions134(values),
    /* Q.83   */ experiment: values => otherOrganisationOptions134(values),
    /* Q.84   */ evaluation: values => otherOrganisationOptions134(values),
    /* Q.85   */ conclusions: values => otherOrganisationOptions134(values) && values.futureCoreActivity === 'No',
    /* Q.86   */ evidenceAvailable: values => otherOrganisationOptions134(values) && values.futureCoreActivity === 'No',
    // tslint:disable-next-line:max-line-length
    /* Q.87   */ evidenceAvailableOther: values => otherOrganisationOptions134(values) && values.futureCoreActivity === 'No' && values.evidenceAvailable !== undefined && values.evidenceAvailable.includes('Other'),
    /* Q.88   */ purpose: otherOrganisationOptions134,
    /* Q.89   */ newKnowledge: values => otherOrganisationOptions134(values) && values.purpose === 'Yes',
    /* Q.90   */ otherOrganisationName: otherOrganisationOptions123,
    /* Q.91   */ briefDescription: otherOrganisationOptions123,
    /* Q.92   */ expenditure: otherOrganisationOptions134,
    /* Q.93.1 */ expenditurePriorToYear1: otherOrganisationOptions134,
    /* Q.93.2 */ financialYear1EstimatedExpenditure: otherOrganisationOptions134,
    /* Q.93.3 */ financialYear2EstimatedExpenditure: otherOrganisationOptions134,
    /* Q.93.4 */ financialYear3EstimatedExpenditure: otherOrganisationOptions134,
    /* Q.93.5 */ financialYear3EstimatedExpenditurePost: otherOrganisationOptions134,
    /* Q.93.6 */ totalExpenditure: otherOrganisationOptions134,
    /* Q.93.H */ totalAnticipatedExpendituresHeader: otherOrganisationOptions134,
    /* Q.93   */ totalAnticipatedExpenditure: otherOrganisationOptions134,
};

export default coreActivities;
